export default {
  getMfcDefault: (state) => state.mfcDefault,
};
